import { Router } from '@angular/router';
import { OnInit } from '@angular/core';

import { Message } from '../../models';
import { SessionService } from '../../services';
import { ModalService } from '../../modules/modal';
import { MessageModalComponent } from '../message/message-modal.component';

export abstract class MenuComponent implements OnInit {

  isStaticMenuShown = false;

  constructor(
    protected router: Router,
    protected sessionService: SessionService,
    protected modalService: ModalService
  ) { }

  ngOnInit(): void {

  }

  goToRouteWithUpeCheck(route: string): void {
    if (this.getUpeId()) {
      this.router.navigate([route]);
      return;
    }

    this.displayMissingUpeMessage();
  }

  getUpeId(): number {
    return this.sessionService.getContainerUpeId();
  }

  private displayMissingUpeMessage(): void {
    this.modalService.openModal({
      component: MessageModalComponent,
      data: {
        title: 'UPE Missing',
        content: 'UPE does not exist for this container. Please create one by clicking on UPE.',
      } as Message,
    });
  }

  // TODO remove it once new design is created or functionality implemented
  public displayTemporaryMessage(): void {
    this.modalService.openModal({
      component: MessageModalComponent,
      data: {
        title: 'Functionality Not Found',
        content: 'This functionality is not yet implemented.',
      } as Message,
    });
  }
}
